import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";

(module => {
    module.component("absoluteDifferences", {
        template: require("./absoluteDifferencesComponent.html"),
        bindings: {
            historicalMarketValue: "<",
            marketPmForecast: "<",
            historicalBrandValue: "<",
            brandPmForecast: "<",
            brandPmForecastAfterCorrection: "<",
            parameters: "<",
            showYears: "<",
            numberPrecision: "@",
            showInMilions: "<"
        },
        controller: [
            "$scope",
            angularServicesNames.$translate,
            "$timeout",
            "absoluteDifferencesService",
            "PPGChartAndTableService",
            "calculationPPGService",
            ToasterService.componentName,
            FileDownloadService.componentName,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                $timeout: ng.ITimeoutService,
                absoluteDifferencesService: $TSFixMe,
                PPGChartAndTableService: $TSFixMe,
                calculationPPGService: $TSFixMe,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService
            ) {
                var $ctrl = this;

                function refreshDebounce() {
                    if (angular.isDefined($scope.watchTimeout)) {
                        $timeout.cancel($scope.watchTimeout);
                    }
                    $scope.watchTimeout = $timeout(function () {
                        calculateAbsoluteDifferences();
                    }, 300);
                }

                function calculateAbsoluteDifferences() {
                    if (
                        !angular.isUndefinedOrNull($ctrl.marketPmForecast) &&
                        !angular.isUndefinedOrNull($ctrl.historicalMarketValue) &&
                        !angular.isUndefinedOrNull($ctrl.historicalBrandValue) &&
                        !angular.isUndefinedOrNull($ctrl.brandPmForecast)
                    ) {
                        var pmMarket = $ctrl.historicalMarketValue.concat($ctrl.marketPmForecast),
                            pmBrand = handleBrandValue($ctrl.historicalBrandValue).concat($ctrl.brandPmForecast),
                            sumPmMarketForecastYearly = calculationPPGService.sumBy(
                                pmMarket,
                                $ctrl.parameters.historicalDataStart,
                                (month: $TSFixMe) => {
                                    return month == 0;
                                }
                            ),
                            sumPmBrandForecastYearly = calculationPPGService.sumBy(
                                pmBrand,
                                $ctrl.parameters.historicalDataStart,
                                (month: $TSFixMe) => {
                                    return month == 0;
                                }
                            ),
                            sumPmMarketForecastQuarter = calculationPPGService.sumBy(
                                pmMarket,
                                $ctrl.parameters.historicalDataStart,
                                (month: $TSFixMe) => {
                                    return month % 3 == 0;
                                }
                            ),
                            sumPmBrandForecastQuarter = calculationPPGService.sumBy(
                                pmBrand,
                                $ctrl.parameters.historicalDataStart,
                                (month: $TSFixMe) => {
                                    return month % 3 == 0;
                                }
                            );

                        var absoluteDifferencesPmMarketForecast =
                            absoluteDifferencesService.calculateAbsoluteDiff(sumPmMarketForecastYearly);
                        var absoluteDifferencesPmBrandForecast =
                            absoluteDifferencesService.calculateAbsoluteDiff(sumPmBrandForecastYearly);

                        var absoluteDifferencesPmMarketQuarters =
                            absoluteDifferencesService.calculateAbsoluteDiffForQuarters(sumPmMarketForecastQuarter);
                        var absoluteDifferencesPmBrandQuarters =
                            absoluteDifferencesService.calculateAbsoluteDiffForQuarters(sumPmBrandForecastQuarter);

                        $ctrl.dataToDisplayYearlyTable = [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_MARKET"),
                                data: absoluteDifferencesPmMarketForecast
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_PRODUCT"),
                                data: absoluteDifferencesPmBrandForecast
                            }
                        ];
                        $ctrl.dataToDisplayQuarter = [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_MARKET"),
                                data: absoluteDifferencesPmMarketQuarters
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_PRODUCT"),
                                data: absoluteDifferencesPmBrandQuarters
                            }
                        ];
                    } else if (
                        !angular.isUndefinedOrNull($ctrl.historicalBrandValue) &&
                        !angular.isUndefinedOrNull($ctrl.brandPmForecast)
                    ) {
                        const pmBrand = handleBrandValue($ctrl.historicalBrandValue).concat($ctrl.brandPmForecast),
                            sumPmBrandForecastYearly = calculationPPGService.sumBy(
                                pmBrand,
                                $ctrl.parameters.historicalDataStart,
                                (month: $TSFixMe) => {
                                    return month == 0;
                                }
                            ),
                            sumPmBrandForecastQuarter = calculationPPGService.sumBy(
                                pmBrand,
                                $ctrl.parameters.historicalDataStart,
                                (month: $TSFixMe) => {
                                    return month % 3 == 0;
                                }
                            );

                        const absoluteDifferencesPmBrandForecast =
                            absoluteDifferencesService.calculateAbsoluteDiff(sumPmBrandForecastYearly);
                        const absoluteDifferencesPmBrandQuarters =
                            absoluteDifferencesService.calculateAbsoluteDiffForQuarters(sumPmBrandForecastQuarter);
                        $ctrl.dataToDisplayYearlyTable = [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_PRODUCT"),
                                data: absoluteDifferencesPmBrandForecast
                            }
                        ];
                        $ctrl.dataToDisplayQuarter = [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_PRODUCT"),
                                data: absoluteDifferencesPmBrandQuarters
                            }
                        ];
                    }
                    addAbsoluteDiffrenceAfterCorrection();
                }

                function handleBrandValue(input: $TSFixMe) {
                    if (input.length == 0) {
                        return _.times($ctrl.historicalMarketValue.length, _.constant(null));
                    }
                    return input;
                }

                function addAbsoluteDiffrenceAfterCorrection() {
                    if (!$ctrl.brandPmForecastAfterCorrection) {
                        return;
                    }

                    const pmBrand = handleBrandValue($ctrl.historicalBrandValue).concat(
                            $ctrl.brandPmForecastAfterCorrection
                        ),
                        sumPmBrandForecastYearly = calculationPPGService.sumBy(
                            pmBrand,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => {
                                return month == 0;
                            }
                        ),
                        sumPmBrandForecastQuarter = calculationPPGService.sumBy(
                            pmBrand,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => {
                                return month % 3 == 0;
                            }
                        );

                    const absoluteDifferencesPmBrandForecast =
                        absoluteDifferencesService.calculateAbsoluteDiff(sumPmBrandForecastYearly);
                    const absoluteDifferencesPmBrandQuarters =
                        absoluteDifferencesService.calculateAbsoluteDiffForQuarters(sumPmBrandForecastQuarter);
                    $ctrl.dataToDisplayYearlyTable.push({
                        header: $translate.instant("FORECAST.PRODUCT.PACKAGE_PRODUCT_AFTER_CORRECTION"),
                        data: absoluteDifferencesPmBrandForecast
                    });
                    $ctrl.dataToDisplayQuarter.push({
                        header: $translate.instant("FORECAST.PRODUCT.PACKAGE_PRODUCT_AFTER_CORRECTION"),
                        data: absoluteDifferencesPmBrandQuarters
                    });
                }

                $scope.$watchGroup(["$ctrl.parameters.historicalDataStart", "$ctrl.parameters.forecastEndDate"], () => {
                    if (!$ctrl.parameters || !$ctrl.parameters.historicalDataStart || !$ctrl.parameters.forecastEndDate)
                        return;
                    $ctrl.labels = PPGChartAndTableService.prepareLabelsToPPG(
                        $ctrl.parameters.historicalDataStart,
                        $ctrl.parameters.forecastEndDate
                    );
                });

                $ctrl.exportTable = function () {
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: $ctrl.labels,

                                rows: _.map($ctrl.dataToDisplayYearlyTable, (x: $TSFixMe) => {
                                    return {
                                        header: x.header,
                                        values: x.data,
                                        decimalPlaces: $ctrl.numberPrecision,
                                        isPercentage: false
                                    };
                                })
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };

                $ctrl.$onInit = () => {
                    $scope.$watch("$ctrl.marketPmForecast", (newVal: $TSFixMe) => {
                        if (newVal) refreshDebounce();
                    });
                    $scope.$watch("$ctrl.historicalMarketValue", (newVal: $TSFixMe) => {
                        if (newVal) refreshDebounce();
                    });
                    $scope.$watch("$ctrl.historicalBrandValue", (newVal: $TSFixMe) => {
                        if (newVal) refreshDebounce();
                    });
                    $scope.$watch("$ctrl.brandPmForecast", (newVal: $TSFixMe) => {
                        if (newVal) refreshDebounce();
                    });

                    if (angular.isUndefinedOrNull($ctrl.numberPrecision)) {
                        $ctrl.numberPrecision = 2;
                    }
                };
            }
        ]
    });
})(angular.module("topline.modules"));
